module.exports = __webpack_public_path__ + "static/media/logo4.27e91709.png";